import type { PublicBarberDTO } from '@nine80/shared';

const NEXT_AVAILABLE = 'next-available';

export function BarberSelect({
  barbers,
  value,
  onChange,
  nextAvailableLabel,
  labelledBy,
}: {
  barbers: PublicBarberDTO[];
  value: number | null;
  onChange: (id: number | null) => void;
  nextAvailableLabel: string;
  labelledBy?: string;
}) {
  return (
    <div
      className="grid grid-cols-2 gap-3 sm:grid-cols-3"
      role="radiogroup"
      aria-labelledby={labelledBy}
    >
      <BarberOption
        selected={value === null}
        label={nextAvailableLabel}
        onClick={() => onChange(null)}
        testId={NEXT_AVAILABLE}
      />
      {barbers.map((b) => (
        <BarberOption
          key={b.id}
          selected={value === b.id}
          label={b.displayName}
          onClick={() => onChange(b.id)}
        />
      ))}
    </div>
  );
}

function BarberOption({
  selected,
  label,
  onClick,
  testId,
}: {
  selected: boolean;
  label: string;
  onClick: () => void;
  testId?: string;
}) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      data-testid={testId}
      onClick={onClick}
      className={`touch-target rounded-card border-2 px-3 py-3 text-center font-medium transition-colors ${
        selected
          ? 'border-primary bg-primary/15 text-primary'
          : 'border-border bg-bg-inset text-fg hover:border-primary/50'
      }`}
    >
      {label}
    </button>
  );
}
